import type { INotificationIcon } from './helpers';

export const NotificationIcon = ({ variant = 'default', ...rest }: INotificationIcon) => (
	<svg
		width='30'
		height='30'
		viewBox='0 0 30 30'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			width='30'
			height='30'
			rx='15'
			fill={variant === 'default' ? 'var(--color-neutral-100)' : 'var(--color-error-50)'}
		/>
		<path
			d='M15.0118 19.9756C13.6526 19.9756 12.2934 19.7598 11.0043 19.3281C10.5143 19.159 10.1409 18.8148 9.97759 18.3656C9.80842 17.9165 9.86675 17.4206 10.1351 16.9773L10.8059 15.8631C10.9459 15.6298 11.0743 15.1631 11.0743 14.889V13.2031C11.0743 11.0331 12.8418 9.26562 15.0118 9.26562C17.1818 9.26562 18.9493 11.0331 18.9493 13.2031V14.889C18.9493 15.1573 19.0776 15.6298 19.2176 15.869L19.8826 16.9773C20.1334 17.3973 20.1801 17.9048 20.0109 18.3656C19.8418 18.8265 19.4743 19.1765 19.0134 19.3281C17.7301 19.7598 16.3709 19.9756 15.0118 19.9756ZM15.0118 10.1406C13.3259 10.1406 11.9493 11.5115 11.9493 13.2031V14.889C11.9493 15.3148 11.7743 15.9448 11.5584 16.3123L10.8876 17.4265C10.7593 17.6423 10.7243 17.8698 10.8001 18.0623C10.8701 18.2606 11.0451 18.4123 11.2843 18.494C13.7226 19.3106 16.3068 19.3106 18.7451 18.494C18.9551 18.424 19.1184 18.2665 19.1943 18.0565C19.2701 17.8465 19.2526 17.619 19.1359 17.4265L18.4651 16.3123C18.2434 15.9331 18.0743 15.309 18.0743 14.8831V13.2031C18.0743 11.5115 16.7034 10.1406 15.0118 10.1406Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
		<path
			d='M16.0967 10.2985C16.0559 10.2985 16.015 10.2926 15.9742 10.281C15.805 10.2343 15.6417 10.1993 15.4842 10.176C14.9884 10.1118 14.51 10.1468 14.0609 10.281C13.8975 10.3335 13.7225 10.281 13.6117 10.1585C13.5009 10.036 13.4659 9.86098 13.53 9.70348C13.7692 9.09098 14.3525 8.68848 15.0175 8.68848C15.6825 8.68848 16.2659 9.08514 16.505 9.70348C16.5634 9.86098 16.5342 10.036 16.4234 10.1585C16.3359 10.2518 16.2134 10.2985 16.0967 10.2985Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
		<path
			d='M15.0117 21.3057C14.4342 21.3057 13.8742 21.0723 13.4659 20.664C13.0576 20.2557 12.8242 19.6957 12.8242 19.1182H13.6992C13.6992 19.4623 13.8392 19.8007 14.0842 20.0457C14.3292 20.2907 14.6676 20.4307 15.0117 20.4307C15.7351 20.4307 16.3242 19.8415 16.3242 19.1182H17.1992C17.1992 20.3257 16.2192 21.3057 15.0117 21.3057Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
	</svg>
);
